import { RouteObject } from 'react-router';

import { ROUTE } from '@app-evolution-cms/router';

export const NOT_FOUND_ROUTES: RouteObject = {
  path: ROUTE.notFound,
  async lazy() {
    const { NotFound } = await import('./not-found');
    return { Component: NotFound };
  },
};
